import addAlert from './addAlert';

const alerts = {
  imported: ['true', 'yes', true],
  car_crashed: ['true', 'yes', true],
  vehicule_type: ['taxi', 'commercial_car', 'driving_school', 'electric', 'car_with_driver', 'diplomatic_car'],
  accident: ['true', 'yes', true],
  painting_anomaly: ['true'],
  body_rear_trunk_floor: ['deformed'],
  motor_longeron: ['deformed'],
  rolling: ['no'],
  road_test_witness: ['yes'],
  hail_damage: ['yes'],
};

export default function generateAlerts(alert, report) {
  const { id, value } = alert;

  if (Object.prototype.hasOwnProperty.call(alerts, id)) {
    if (alerts[id].includes(value)) addAlert(report, id, value);
    return;
  }

  if (alert.type === 'select_alerts' && typeof value === 'object') {
    Object.entries(value).forEach((key) => {
      if (key[1]) addAlert(report, key[0], key[1]);
      else addAlert(report, key[0], null);
    });
  }
}
